// Hash Generator Tool — SHA-1/256/384/512 digests via the Web Crypto API.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const hashGeneratorTool: Tool = {
  id: "hash-generator",
  name: () => m.hg_tool_name(),
  description: () => m.hg_tool_description(),
  icon: "🔐",
  basePath: "/hash-generator",
  status: "stable",
  tags: ["hash", "sha256", "checksum", "developer"],
  pages: [
    {
      name: () => m.hg_nav_main(),
      path: "/hash-generator",
      description: () => m.hg_nav_main_desc(),
      icon: "🔐",
    },
  ],
};
